import React from "react";

import CodeInput from "./CodeInput"

import Codes from "../common/Codes"
import Input from "./Input";
import SmartList from "../common/SmartList";

export default class Documents extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            editable: props.editable,
            documents: props.documents,
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState(nextProps)
    }

    _renderDocuments(document, index){
        let {
            editable,
            documents
        } = this.state

      const hidden = this.props.hidden
      let placeholder = this.props.placeholder

      return (
          <div className="form-group row mb-5">
            <div
              className="col-md-3"
              hidden={hidden("documents.type")}
            >
              <CodeInput
                listKey={this.props.listKey}
                value={document.type}
                placeholder={placeholder("document.type", "Document Type")}
                editable={editable}
                onSelected={option => {
                  documents[index].type = option
                  this.props.onUpdated(documents)
                }}
              />
            </div>
            <div
              className="col-md-3"
              hidden={hidden("documents.identifier")}
            >
              <Input
                type="text"
                value={document.identifier}
                placeholder={placeholder("document.identifier", "Document Identifier")}
                editable={editable}
                onChange={identifier => {
                  documents[index].identifier = identifier
                  this.props.onUpdated(documents)
                }}
              />
            </div>
            <div
              className="col-md-3"
              hidden={hidden("documents.name")}
            >
              <Input
                type="text"
                value={document.name}
                placeholder={placeholder("document.name", "Document Name")}
                editable={editable}
                onChange={identifier => {
                  documents[index].name = identifier
                  this.props.onUpdated(documents)
                }}
              />
            </div>
            <div
              className="col-md-3"
              hidden={hidden("documents.lpco_exemption_code")}
            >
              <CodeInput
                placeholder={"LPCO Exemption Code"}
                listKey={"DocumentStatusCode_CDS_Import"}
                value={document.lpco_exemption_code}
                placeholder={placeholder("document.lpco_exemption_code", "LPCO Exemption Code")}
                editable={editable}
                onSelected={option => {
                  documents[index].lpco_exemption_code = option
                  this.props.onUpdated(documents)
                }}
              />
            </div>
          </div>
        )
    }


  render() {
    let {
      editable,
      documents,
    } = this.state

    let itemName = "Document"
    return (
      <SmartList
        minimal
        items={documents}
        itemName={itemName}
        showItemName={true}
        canDelete={editable}
        canAdd={editable}
        renderItem={(document, index) => this._renderDocuments(document, index)}
        renderDelete={(item, index) => (
          <a
              className="btn btn-sm btn-light-danger"
              onClick={() => {
                  documents.splice(index, 1)
                  this.props.onUpdated(documents)
              }}
          >
              <i className="la la-trash-o fs-3"></i>
              {itemName}
          </a>
        )}
        onUpdated={items => {
            documents = items
            this.props.onUpdated(documents)
        }}
        onAddItemPressed={() => {
            documents.push({})
            this.props.onUpdated(documents)
        }}
      />
    )
  }
}

Documents.defaultProps = {
  listKey: "CommonDocumentsType"
}
